<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive
      code="fermeture_ouinon"
      :live="liveSasSociete(25931)"
      v-model="sasSociete.declarerLaFermetureDUnePharmacie"
      :disabled="sas.fermetures.length === 0"
      @eudo-updated="desactiverFermeture"
    />
    <div v-show="conditionFermeture">
      <data-iterator
        :list="getListFermeture"
        add-new-text="Fermer une pharmacie"
        :live="{ endpoint: 'sas-fermeture-pharmacie', sasId: sas.id }"
        :icon="$getIcon('job')"
        :valids="valids"
        ref="dataIterator"
        hidePoints
        hideAddButton
        cardWidth="850"
        optional
      >
        <template v-slot:show-mode="{ item }">
          <OrganisationCardContent
            v-if="item.pharmacieFermee"
            :organisation="item.pharmacieFermee"
          />
          <CaseACocherLive
            @eudo-updated="cocherFermee(item)"
            code="fermeture_est_fermee"
            v-model="item.fermee"
            :live="liveSasFermeture(26407, item)"
            :ref="getId('fermee', item)"
          />
        </template>
        <template v-slot:edit-mode="{ item }">
          <OrganisationCardContent
            v-if="item.pharmacieFermee"
            :organisation="item.pharmacieFermee"
            class="mb-6"
          />
          <DatePickerLive
            :opqIf="item.fermee"
            code="fermeture_date"
            v-model="item.dateDeFermeture"
            :live="liveSasFermeture(26403, item)"
            :minValue="serverDate()"
            :ref="getId('dateDeFermeture', item)"
          />
          <FileInput
            code="fermeture_lettre_substances_controlees"
            :opqIf="item.fermee"
            :file="item.lettreSubstancesControlees"
            :live="liveSasFermeture(26404, item)"
            :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
            :ref="getId('lettreSubstancesControlees', item)"
          />

          <div v-if="item.fermee">
            <ressource code="acquereurs_info" />
          </div>
          <data-iterator
            :opqIf="item.fermee"
            :list="item.sasAcquereurs"
            add-new-text="selectionner les acquéreurs"
            :live="{
              endpoint: 'sas-acquereur',
              sasId: sas.id,
              payload: { sasFermetureLie: item.id },
            }"
            :icon="$getIcon('job')"
            hidePoints
            withoutValidation
          >
            <template v-slot:show-mode="{ item }">
              <OrganisationCardContent
                v-if="item.acquereur"
                :organisation="item.acquereur"
              />
              <v-chip color="secondary lighten-2"
                >{{ item.pourcentageCibles }} %</v-chip
              >
            </template>
            <template v-slot:edit-mode="{ item }">
              <SearchPharmacie
                v-if="!item.acquereur"
                @organisation-selected="organisationSelected(item, $event)"
                label="Saisissez le nom ou l'adresse des acquéreurs des médicaments et poisons"
                :idToExclude="idToExcludeAcquereur(item)"
              ></SearchPharmacie>
              <OrganisationCardContent
                v-if="item.acquereur"
                :organisation="item.acquereur"
                class="mb-4"
              />
              <v-checkbox
                class="list_counter_validator mb-2 ml-6 p-0"
                :rules="[
                  () =>
                    !!item.acquereur ||
                    'Vous devez sélectionner une pharmacie acquéreuse.',
                ]"
                :input-value="!!item.acquereur"
              />
              <NumberLive
                code="fermeture_acquereurs_pourcentage"
                v-model="item.pourcentageCibles"
                :live="liveSasAcquereur(26503, item)"
              />
              <FileInput
                code="fermeture_acquereurs_declaration"
                :file="item.declarationAcquereur"
                :live="liveSasAcquereur(26504, item)"
                :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
              />
            </template>
          </data-iterator>

          <div v-if="item.fermee">
            <ressource code="pharmacie_transfert_info" />
          </div>
          <SearchPharmacie
            v-if="item.fermee && !item.pharmacieDeTransfert"
            @organisation-selected="organisationFermeeSelected(item, $event)"
            label="Saisissez le nom ou l'adresse de la pharmacie où le transfert aura lieu"
            :idToExclude="idOrganisationToExclude"
            isAcquereur
          >
          </SearchPharmacie>

          <v-card
            v-if="item.fermee && item.pharmacieDeTransfert"
            max-width="420"
            class="px-6 py-4"
            color="primary"
            dark
          >
            <OrganisationCardContent
              :organisation="item.pharmacieDeTransfert"
            />
          </v-card>
          <v-btn
            v-if="item.pharmacieDeTransfert"
            text
            color="primary"
            @click="viderPharmacieTransfert(item)"
            >Modifier la pharmacie de transfert</v-btn
          >
          <v-checkbox
            v-if="item.fermee"
            class="list_counter_validator mb-2 ml-6 p-0"
            :rules="[
              () =>
                !!item.pharmacieDeTransfert ||
                'Vous devez sélectionner une pharmacie de transfert.',
            ]"
            :input-value="!!item.pharmacieDeTransfert"
          />

          <FileInput
            code="fermeture_declaration_preneur"
            :opqIf="item.fermee"
            :file="item.declarationPreneurDesDossiersPatients"
            :live="liveSasFermeture(26405, item)"
            :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
            :ref="getId('declarationPreneurDesDossiersPatients', item)"
          />
        </template>
      </data-iterator>
    </div>
    <validate
      :that="
        !conditionFermeture ||
        (conditionFermeture && getListFermeture.some((x) => x.fermee))
      "
      else="condition_fermeture"
    />
  </v-form>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import OrganisationCardContent from "@/components/Common/OrganisationCardContent.vue"
import { Queue, Api } from "@/plugins/api"
import SearchPharmacie from "@/components/Formulaires/DemandeEnregistrementSociete/component/SearchPharmacie.vue"
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers, DatesHelpers],
  components: { OrganisationCardContent, SearchPharmacie },
  props: {
    sas: { type: Object },
  },
  computed: {
    sasSociete() {
      return this.sas.sasSociete
    },
    conditionFermeture() {
      return this.estOui(this.sas.sasSociete.declarerLaFermetureDUnePharmacie)
    },
    idOrganisationToExclude() {
      return this.sas.fermetures
        .filter((x) => x.fermee && x.pharmacieFermee)
        .map((x) => x.pharmacieFermee.organisationId)
    },
    getListFermeture() {
      return this.sas.fermetures.filter(
        (fermeture) =>
          !this.sas.demenagements.some(
            (demenagement) =>
              demenagement.pharmacieDemenagee &&
              demenagement.pharmacieDemenagee.organisationId ===
                fermeture.pharmacieFermee.organisationId &&
              demenagement.dateDemenagement !== null
          ) &&
          !this.sas.ventesPharmacie.some(
            (vente) =>
              vente.ventePharmacie &&
              vente.ventePharmacie.organisationId ===
                fermeture.pharmacieFermee.organisationId &&
              vente.dateVente !== null
          )
      )
    },
  },
  methods: {
    liveSasFermeture(cle, item) {
      return { endpoint: "sas-fermeture-pharmacie", cle: cle, fileId: item.id }
    },
    liveSasAcquereur(cle, item) {
      return { endpoint: "sas-acquereur", cle: cle, fileId: item.id }
    },
    liveSasSociete(cle) {
      return { endpoint: "sas-societe", cle: cle, fileId: this.sasSociete.id }
    },
    getId(key, item) {
      return `${key}_fermeture_${item.id}`
    },
    cocherFermee(item) {
      if (!item.fermee) {
        this.viderChampPharmacie(item)
      } else {
        item.isExpanded = true
      }
    },
    viderPharmacieTransfert(fermeture) {
      Queue.enqueue(() =>
        Api.post("sas-fermeture-pharmacie", {
          fileId: fermeture.id,
          cle: "26406",
          value: null,
        }).then(() => {
          fermeture.pharmacieDeTransfert = null
        })
      )
    },
    viderChampPharmacie(fermeture) {
      this.viderPharmacieTransfert(fermeture)
      fermeture.sasAcquereurs.forEach((acquereur) =>
        Queue.enqueue(() =>
          Api.post("sas-acquereur" + "/delete/" + acquereur.id).then(() => {
            fermeture.sasAcquereurs.splice(
              fermeture.sasAcquereurs.indexOf(acquereur),
              1
            )
          })
        ).finally(() => {
          this.$emit("deleteItem")
        })
      )
    },
    desactiverFermeture() {
      if (!this.conditionFermeture) {
        this.sas.fermetures.forEach((fermeture) => {
          this.viderChampPharmacie(fermeture)
          const fermee = this.$refs[this.getId("fermee", fermeture)]
          fermee.setValue(false)
        })
      }
    },
    organisationSelected(item, org) {
      Queue.enqueue(() =>
        Api.post("sas-acquereur", {
          fileId: item.id,
          cle: "300",
          value: org.organisationId,
        }).then(() => {
          item.acquereur = org
        })
      )
    },
    organisationFermeeSelected(item, org) {
      Queue.enqueue(() =>
        Api.post("sas-fermeture-pharmacie", {
          fileId: item.id,
          cle: "26406",
          value: org.organisationId,
        }).then(() => {
          item.pharmacieDeTransfert = org
        })
      )
    },
    idToExcludeAcquereur(acquereur) {
      const fermeture = this.sas.fermetures.find(
        (x) => x.id === acquereur.sasFermetureLie
      )
      const autreAcquereurs = (fermeture.sasAcquereurs || [])
        .filter((x) => x.acquereur)
        .map((x) => x.acquereur.organisationId)
      return this.idOrganisationToExclude.concat(autreAcquereurs)
    },
  },
}
</script>

<style></style>
